import { Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { SITE, UNITS, NAV_ITEMS } from "../../lib/site";
import NexusLogo from "./NexusLogo";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 bg-[#050406] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <NexusLogo className="h-9" showGroup={false} />
            <p className="mt-6 max-w-md text-[14.5px] text-[#a19eb0] leading-relaxed">
              O Grupo Nexus reúne conectividade, monitoramento, infraestrutura e inovação digital
              em um único ecossistema de tecnologia.
            </p>
            <div className="mt-6 flex items-center gap-2">
              <a
                href={SITE.socials.instagram}
                target="_blank"
                rel="noreferrer noopener"
                data-testid="footer-social-instagram"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] hover:bg-white/[0.08] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={16} />
              </a>
              <a
                href={SITE.socials.facebook}
                target="_blank"
                rel="noreferrer noopener"
                data-testid="footer-social-facebook"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] hover:bg-white/[0.08] transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={16} />
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.2em] text-white/50">Navegação</div>
            <ul className="mt-5 space-y-3">
              {NAV_ITEMS.map((n) => (
                <li key={n.id}>
                  <a
                    href={`#${n.id}`}
                    className="text-[14px] text-white/75 hover:text-white transition-colors"
                    data-testid={`footer-nav-${n.id}`}
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.2em] text-white/50">Empresas</div>
            <ul className="mt-5 space-y-3">
              {UNITS.map((u) => (
                <li key={u.id}>
                  <span className="text-[14px] text-white/75">{u.name}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.2em] text-white/50">Contato</div>
            <ul className="mt-5 space-y-3 text-[14px]">
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  className="text-white/80 hover:text-white"
                  data-testid="footer-email"
                >
                  {SITE.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:+${SITE.phoneRaw}`}
                  className="text-white/80 hover:text-white"
                  data-testid="footer-phone"
                >
                  {SITE.phoneLabel}
                </a>
              </li>
              <li>
                <a
                  href={SITE.mapsUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="text-white/80 hover:text-white inline-flex items-center gap-1"
                  data-testid="footer-maps"
                >
                  Ver no Google Maps <ArrowUpRight size={12} />
                </a>
              </li>
              <li>
                <a
                  href={`https://${SITE.domain}`}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="text-white/80 hover:text-white inline-flex items-center gap-1"
                  data-testid="footer-site"
                >
                  {SITE.domain} <ArrowUpRight size={12} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-[12.5px] text-white/40">
            © {year} Grupo Nexus. Todos os direitos reservados.
          </p>
          <p className="text-[12px] text-white/35">
            Feito com precisão técnica · <span className="nx-rainbow-text">Nexus</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
